import { getTemplateSubCategories } from 'templates/api';
import { TemplateCategoryModel } from 'templates/types';
import { sortSubcategoriesAlphabetical } from 'templates/utils';
import { createWithEqualityFn } from 'zustand/traditional';

type SubCategoryState = {
  subCategories: Array<TemplateCategoryModel> | null;
  isLoading: boolean;
  fetchSubCategoryData: (category: string, segments?: string[]) => Promise<void>;
};

const useSubCategoryDataStore = createWithEqualityFn<SubCategoryState>(set => ({
  subCategories: [],
  isLoading: true,
  fetchSubCategoryData: async (category, segments) => {
    set({ isLoading: true });
    const headers = {
      segments,
    };
    const subCategoriesData = await getTemplateSubCategories(category, headers);
    const sortedSubCategories = sortSubcategoriesAlphabetical(subCategoriesData.data);
    set({
      subCategories: sortedSubCategories,
      isLoading: false,
    });
  },
}));

export default useSubCategoryDataStore;
